var bodyScroll = wt; // A spécifier dans variables.js

function fixBody(){
    bodyScroll = $window.scrollTop();
    $body.css({
        'position' : 'fixed',
        'width' : '100%',
        'top': -bodyScroll,
        'overflow' : 'hidden'
    });
    $(window).scrollTop(0);
}

function unfixBody(){
    $body.css({
        'position' : 'static',
        'top': '0',
        'overflow' : 'auto'
    });
    $window.scrollTop(bodyScroll);
}


function minWidth(width, fc1, fc2) {
    fc1 = fc1 || (function(){});
    fc2 = fc2 || (function(){});
    if (ww >= width) {
        fc1();
    } else {
        fc2();
    }
}

function checkWindowWidth(fc1, fc2, fc3) {
    fc1 = fc1 || (function(){});
    fc2 = fc2 || (function(){});
    fc3 = fc3 || (function(){});

    if (ww <= screenSm) {
        fc1();
    } else if ((ww <= screenMd)) {
        fc2();
    } else {
        fc3();
    }
}

String.prototype.trimToLength = function(m) {
  return (this.length > m) 
    ? jQuery.trim(this).substring(0, m).split(" ").slice(0, -1).join(" ") + "..."
    : this;
};
